import {
  errorRequestId,
  isApiError,
  NetworkError,
  NON_RETRYABLE_ERROR_CODES,
  UnknownResultError,
} from '@saay/api-client';

/** D-76 / Q12: copyable request ID only for technical failures and unknown outcomes. */
export function shouldShowRequestId(error: unknown): boolean {
  if (error instanceof UnknownResultError) {
    return true;
  }
  if (error instanceof NetworkError) {
    return true;
  }
  if (!isApiError(error)) {
    return true;
  }
  if (error.status >= 500 || NON_RETRYABLE_ERROR_CODES.has(error.code)) {
    return true;
  }
  return false;
}

export function copyableRequestId(error: unknown): string | null {
  if (!shouldShowRequestId(error)) {
    return null;
  }
  const id = errorRequestId(error);
  return id === null || id === '' ? null : id;
}
